import logo from '../../../../assets/images/logo_side_cropped.png';
import { dashboardSidebarLinks } from './DashboardSidebar.data';
import DashboardSidebarItem from './DashboardSidebarItem/DashboardSidebarItem';
import { ReactComponent as LogoutIcon } from '../../../../assets/vectors/logout.svg';
import { Link, useNavigate } from 'react-router-dom';
import { DashboardSidebarProps } from './DashboardSidebar.types';
import { useCurrentUser } from '../../../../hooks/useCurrentUser/useCurrentUser';
import { useMemo, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { signOut } from '../../../../store/authentication/authenticationActions/authenticationActions';
import { getLoginUrlByRole } from '../../../../utils/helpers/router/getLoginUrlByRole';
import { UserRoles } from '../../../../types/models/user/user.types';
import { ReactComponent as MenuIcon } from '../../../../assets/vectors/menu.svg';
import { Commercial, CommercialTypes } from '../../../../types/api/endpoints/commercial/commercial.types';

export default ({ currentView }: DashboardSidebarProps) => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const currentUser = useCurrentUser();

  const [isActive, setActive] = useState(false);

  const currentItemsList = useMemo(() => {
    if (currentUser) {
      if (currentUser.role === UserRoles.Commercial) {
        const { type, role } = currentUser as Commercial

        if (type === CommercialTypes.Employee) {
          return dashboardSidebarLinks[role].map((link) => {
            if (link.label === 'Facturation') {
              return {
                ...link,
                label: 'Commissions'
              }
            } else {
              return link
            }
          })
        } else {
          return dashboardSidebarLinks[role];
        }
      } else {
        return dashboardSidebarLinks[currentUser?.role];
      }
    } else {
      return [];
    }
  }, [currentUser]);

  return (
    <div className={`dashboard__sidebar${isActive ? ' dashboard__sidebar--active' : ''}`}>
      <div className="dashboard__sidebar-main">
        <div className="flex-column">
          <Link to="/dashboard">
            <img className="dashboard__logo" src={logo} />
          </Link>
          <div className="dashboard__sidebar-list">
            {currentItemsList?.map(({ icon, label, path }, index) => (
              <DashboardSidebarItem
                key={index}
                to={`/dashboard/${path}`}
                isActive={path.split('/')[0] === currentView}
                isCompany={currentUser?.role === UserRoles.Entreprise}
                {...{ icon, label }}
              />
            ))}
          </div>
        </div>
        <DashboardSidebarItem
          icon={LogoutIcon}
          label="Se déconnecter"
          isActive={false}
          to={getLoginUrlByRole(currentUser?.role)}
          onClick={() =>
            signOut(queryClient)(dispatch).then(() =>
              navigate(getLoginUrlByRole(currentUser?.role))
            )
          }
        />
      </div>
      <div
        className={`dashboard__sidebar-trigger-box`}
        onClick={() => setActive((state) => !state)}>
        <MenuIcon className="dashboard__sidebar-trigger" />
      </div>
    </div>
  );
};
